import { PreAuthorization } from './PreAuthorizations';

export const isValidPreAuthorization = (
  preAuthorization: Partial<PreAuthorization> | undefined,
): preAuthorization is Pick<
  PreAuthorization,
  'status' | 'startAt' | 'expiresAt' | 'currency' | 'remainingAmount' | 'uid'
> => {
  return (
    !!preAuthorization &&
    !!preAuthorization?.status &&
    !!preAuthorization?.currency &&
    !!preAuthorization?.startAt &&
    !!preAuthorization?.remainingAmount
  );
};
